<template>
    <div class="ly-dashboard">
        <img src="./dd.png" alt="">
    </div>
</template>
<script>
    export default {
        name: 'LyDashboard'
    }
</script>

<style>
    .ly-dashboard img{
        width: 100%;
        height: auto;
    }
</style>



// WEBPACK FOOTER //
// ../projectCore/src/components/ly-dashboard/src/index.vue